import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../Interfaces.style';
import WorklistServers from './WorklistServers';

const WorklistInterfaces = ({ setReportRulesChanged }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography
        variant='h6'
        color='primary'
        className={`${classes.titleSettingsCard} ${classes.title_margin}`}>
        {t('Settings.worklist_interfaces')}
      </Typography>

      <WorklistServers setReportRulesChanged={setReportRulesChanged} />
    </>
  );
};

export default WorklistInterfaces;
